import { render } from "./EditCategory.vue?vue&type=template&id=7d4746cb&scoped=true"
import script from "./EditCategory.vue?vue&type=script&lang=js"
export * from "./EditCategory.vue?vue&type=script&lang=js"

import "./EditCategory.vue?vue&type=style&index=0&id=7d4746cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4746cb"]])

export default __exports__